import { TextareaAutosize } from '@material-ui/core'
import styled, { css } from 'styled-components'

import { TEXT_TYPE } from './Text'

interface EditableTextareaProps {
  $type: TEXT_TYPE
}

const EditableTextarea = styled(TextareaAutosize)<EditableTextareaProps>`
  resize: none;
  flex: 1;
  background: transparent;
  border: 0;
  outline: none;
  width: 100%;
  color: ${({ theme }) => theme.palette.text.primary};
  margin: -2px;

  ${({ $type }) => {
    switch ($type) {
      case TEXT_TYPE.H1:
        return css`
          font-size: 96px;
          line-height: 150%;
        `

      case TEXT_TYPE.H2:
        return css`
          font-size: 60px;
          line-height: 150%;
        `

      case TEXT_TYPE.H3:
        return css`
          font-size: 48px;
          line-height: 150%;
        `

      case TEXT_TYPE.H4:
        return css`
          font-size: 32px;
          line-height: 150%;
        `

      case TEXT_TYPE.H5:
        return css`
          font-size: 24px;
          line-height: 150%;
        `

      case TEXT_TYPE.H6:
        return css`
          font-size: 20px;
          line-height: 150%;
        `

      case TEXT_TYPE.LARGE:
        return css`
          font-size: 16px;
          line-height: 157%;
        `

      case TEXT_TYPE.BODY:
        return css`
          font-size: 14px;
          line-height: 157%;
        `

      case TEXT_TYPE.SMALL:
        return css`
          font-size: 12px;
          line-height: 157%;
        `

      default:
        return css``
    }
  }}
`

export default EditableTextarea
